import React from "react";

export default function Home() {
    return (
        <div className="App">
           <h1>Home</h1>
        </div>
    );
}
